import { g as getDefaultExportFromCjs, c as createCommonjsModule } from './common/_commonjsHelpers-8c19dec8.js';
import './@pixi/polyfill.js';
import { u as utils } from './common/utils-3a587c1c.js';
import { a as accessibility } from './common/accessibility-afb5fccc.js';
import { i as interaction } from './common/interaction-4070de13.js';
import { a as app } from './common/app-d6f984bd.js';
import { c as core } from './common/core-acb1f189.js';
import { e as extract } from './common/extract-cc76ee4c.js';
import { l as loaders } from './common/loaders-bf79210a.js';
import { c as compressedTextures } from './common/compressed-textures-1b9e198f.js';
import { p as particleContainer } from './common/particle-container-af397fbf.js';
import { p as prepare } from './common/prepare-fa7e6ae0.js';
import { s as spritesheet } from './common/spritesheet-467a6334.js';
import { s as spriteTiling } from './common/sprite-tiling-d54fdde7.js';
import { t as textBitmap } from './common/text-bitmap-e85d4c9a.js';
import { t as ticker } from './common/ticker-c5946345.js';
import { f as filterAlpha } from './common/filter-alpha-859261eb.js';
import { f as filterBlur } from './common/filter-blur-7306db9f.js';
import { f as filterColorMatrix } from './common/filter-color-matrix-3ea3db49.js';
import { f as filterDisplacement } from './common/filter-displacement-30796177.js';
import { f as filterFxaa } from './common/filter-fxaa-9cca1285.js';
import { f as filterNoise } from './common/filter-noise-1ee6eccd.js';
import './common/mixin-cache-as-bitmap-9a82b17b.js';
import './@pixi/mixin-get-child-by-name.js';
import './@pixi/mixin-get-global-position.js';
import { c as constants } from './common/constants-614db509.js';
import { d as display } from './common/display-02d955d1.js';
import { g as graphics } from './common/graphics-0fb902e5.js';
import { m as math } from './common/math-4b280615.js';
import { m as mesh } from './common/mesh-65910b6c.js';
import { m as meshExtras } from './common/mesh-extras-d205c695.js';
import { r as runner } from './common/runner-46c151f4.js';
import { s as sprite } from './common/sprite-254dc1ef.js';
import { s as spriteAnimated } from './common/sprite-animated-b4fc7964.js';
import { t as text } from './common/text-7f4f5a5d.js';
import { s as settings_1 } from './common/settings-74edbb19.js';
import './common/index-f94d5a70.js';
import './common/index-d01087d6.js';
import './common/index-f7276418.js';
import './common/earcut-2ad6c5fa.js';
import './common/url-a096fc32.js';
import './common/punycode-03dd95bc.js';
import './common/index-c9b49f27.js';

var pixi = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });





































function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return n;
}

var utils__namespace = /*#__PURE__*/_interopNamespace(utils);

// Install renderer plugins
core.Renderer.registerPlugin('accessibility', accessibility.AccessibilityManager);
core.Renderer.registerPlugin('extract', extract.Extract);
core.Renderer.registerPlugin('interaction', interaction.InteractionManager);
core.Renderer.registerPlugin('particle', particleContainer.ParticleRenderer);
core.Renderer.registerPlugin('prepare', prepare.Prepare);
core.Renderer.registerPlugin('batch', core.BatchRenderer);
core.Renderer.registerPlugin('tilingSprite', spriteTiling.TilingSpriteRenderer);
// Install loader plugins
loaders.Loader.registerPlugin(textBitmap.BitmapFontLoader);
loaders.Loader.registerPlugin(compressedTextures.CompressedTextureLoader);
loaders.Loader.registerPlugin(compressedTextures.DDSLoader);
loaders.Loader.registerPlugin(compressedTextures.KTXLoader);
loaders.Loader.registerPlugin(spritesheet.SpritesheetLoader);
// Install application plugins
app.Application.registerPlugin(ticker.TickerPlugin);
app.Application.registerPlugin(loaders.AppLoaderPlugin);
/**
 * String of the current PIXI version.
 * @static
 * @constant
 * @memberof PIXI
 * @name VERSION
 * @type {string}
 */
var VERSION = '6.4.0';
/**
 * @namespace PIXI
 */
/**
 * This namespace contains WebGL-only display filters that can be applied
 * to DisplayObjects using the {@link PIXI.DisplayObject#filters filters} property.
 *
 * Since PixiJS only had a handful of built-in filters, additional filters
 * can be downloaded {@link https://github.com/pixijs/pixi-filters here} from the
 * PixiJS Filters repository.
 *
 * All filters must extend {@link PIXI.Filter}.
 * @example
 * // Create a new application
 * const app = new PIXI.Application();
 *
 * // Draw a green rectangle
 * const rect = new PIXI.Graphics()
 *     .beginFill(0x00ff00)
 *     .drawRect(40, 40, 200, 200);
 *
 * // Add a blur filter
 * rect.filters = [new PIXI.filters.BlurFilter()];
 *
 * // Display rectangle
 * app.stage.addChild(rect);
 * document.body.appendChild(app.view);
 * @namespace PIXI.filters
 */
var filters = {
    AlphaFilter: filterAlpha.AlphaFilter,
    BlurFilter: filterBlur.BlurFilter,
    BlurFilterPass: filterBlur.BlurFilterPass,
    ColorMatrixFilter: filterColorMatrix.ColorMatrixFilter,
    DisplacementFilter: filterDisplacement.DisplacementFilter,
    FXAAFilter: filterFxaa.FXAAFilter,
    NoiseFilter: filterNoise.NoiseFilter,
};

exports.utils = utils__namespace;
exports.VERSION = VERSION;
exports.filters = filters;
Object.keys(accessibility).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return accessibility[k]; }
    });
});
Object.keys(interaction).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return interaction[k]; }
    });
});
Object.keys(app).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return app[k]; }
    });
});
Object.keys(core).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return core[k]; }
    });
});
Object.keys(extract).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return extract[k]; }
    });
});
Object.keys(loaders).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return loaders[k]; }
    });
});
Object.keys(compressedTextures).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return compressedTextures[k]; }
    });
});
Object.keys(particleContainer).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return particleContainer[k]; }
    });
});
Object.keys(prepare).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return prepare[k]; }
    });
});
Object.keys(spritesheet).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return spritesheet[k]; }
    });
});
Object.keys(spriteTiling).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return spriteTiling[k]; }
    });
});
Object.keys(textBitmap).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return textBitmap[k]; }
    });
});
Object.keys(ticker).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return ticker[k]; }
    });
});
Object.keys(constants).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return constants[k]; }
    });
});
Object.keys(display).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return display[k]; }
    });
});
Object.keys(graphics).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return graphics[k]; }
    });
});
Object.keys(math).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return math[k]; }
    });
});
Object.keys(mesh).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return mesh[k]; }
    });
});
Object.keys(meshExtras).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return meshExtras[k]; }
    });
});
Object.keys(runner).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return runner[k]; }
    });
});
Object.keys(sprite).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return sprite[k]; }
    });
});
Object.keys(spriteAnimated).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return spriteAnimated[k]; }
    });
});
Object.keys(text).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return text[k]; }
    });
});
Object.keys(settings_1).forEach(function (k) {
    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () { return settings_1[k]; }
    });
});

});

var __pika_web_default_export_for_treeshaking__ = /*@__PURE__*/getDefaultExportFromCjs(pixi);

var ALPHA_MODES = pixi.ALPHA_MODES;
var AbstractBatchRenderer = pixi.AbstractBatchRenderer;
var AbstractMultiResource = pixi.AbstractMultiResource;
var AbstractRenderer = pixi.AbstractRenderer;
var AccessibilityManager = pixi.AccessibilityManager;
var AnimatedSprite = pixi.AnimatedSprite;
var AppLoaderPlugin = pixi.AppLoaderPlugin;
var Application = pixi.Application;
var ArrayResource = pixi.ArrayResource;
var Attribute = pixi.Attribute;
var BLEND_MODES = pixi.BLEND_MODES;
var BUFFER_BITS = pixi.BUFFER_BITS;
var BUFFER_TYPE = pixi.BUFFER_TYPE;
var BaseImageResource = pixi.BaseImageResource;
var BasePrepare = pixi.BasePrepare;
var BaseRenderTexture = pixi.BaseRenderTexture;
var BaseTexture = pixi.BaseTexture;
var BatchDrawCall = pixi.BatchDrawCall;
var BatchGeometry = pixi.BatchGeometry;
var BatchPluginFactory = pixi.BatchPluginFactory;
var BatchRenderer = pixi.BatchRenderer;
var BatchShaderGenerator = pixi.BatchShaderGenerator;
var BatchSystem = pixi.BatchSystem;
var BatchTextureArray = pixi.BatchTextureArray;
var BitmapFont = pixi.BitmapFont;
var BitmapFontData = pixi.BitmapFontData;
var BitmapFontLoader = pixi.BitmapFontLoader;
var BitmapText = pixi.BitmapText;
var BlobResource = pixi.BlobResource;
var Bounds = pixi.Bounds;
var Buffer = pixi.Buffer;
var BufferResource = pixi.BufferResource;
var CLEAR_MODES = pixi.CLEAR_MODES;
var CanvasResource = pixi.CanvasResource;
var Circle = pixi.Circle;
var CompressedTextureLoader = pixi.CompressedTextureLoader;
var CompressedTextureResource = pixi.CompressedTextureResource;
var Container = pixi.Container;
var ContextSystem = pixi.ContextSystem;
var CountLimiter = pixi.CountLimiter;
var CubeResource = pixi.CubeResource;
var DDSLoader = pixi.DDSLoader;
var DEG_TO_RAD = pixi.DEG_TO_RAD;
var DRAW_MODES = pixi.DRAW_MODES;
var DisplayObject = pixi.DisplayObject;
var ENV = pixi.ENV;
var Ellipse = pixi.Ellipse;
var Extract = pixi.Extract;
var FORMATS = pixi.FORMATS;
var FORMATS_TO_COMPONENTS = pixi.FORMATS_TO_COMPONENTS;
var FillStyle = pixi.FillStyle;
var Filter = pixi.Filter;
var FilterState = pixi.FilterState;
var FilterSystem = pixi.FilterSystem;
var Framebuffer = pixi.Framebuffer;
var FramebufferSystem = pixi.FramebufferSystem;
var GC_MODES = pixi.GC_MODES;
var GLFramebuffer = pixi.GLFramebuffer;
var GLProgram = pixi.GLProgram;
var GLTexture = pixi.GLTexture;
var GRAPHICS_CURVES = pixi.GRAPHICS_CURVES;
var Geometry = pixi.Geometry;
var GeometrySystem = pixi.GeometrySystem;
var Graphics = pixi.Graphics;
var GraphicsData = pixi.GraphicsData;
var GraphicsGeometry = pixi.GraphicsGeometry;
var IGLUniformData = pixi.IGLUniformData;
var INSTALLED = pixi.INSTALLED;
var INTERNAL_FORMATS = pixi.INTERNAL_FORMATS;
var INTERNAL_FORMAT_TO_BYTES_PER_PIXEL = pixi.INTERNAL_FORMAT_TO_BYTES_PER_PIXEL;
var ImageBitmapResource = pixi.ImageBitmapResource;
var ImageResource = pixi.ImageResource;
var InteractionData = pixi.InteractionData;
var InteractionEvent = pixi.InteractionEvent;
var InteractionManager = pixi.InteractionManager;
var InteractionTrackingData = pixi.InteractionTrackingData;
var KTXLoader = pixi.KTXLoader;
var LINE_CAP = pixi.LINE_CAP;
var LINE_JOIN = pixi.LINE_JOIN;
var LineStyle = pixi.LineStyle;
var Loader = pixi.Loader;
var LoaderResource = pixi.LoaderResource;
var MASK_TYPES = pixi.MASK_TYPES;
var MIPMAP_MODES = pixi.MIPMAP_MODES;
var MSAA_QUALITY = pixi.MSAA_QUALITY;
var MaskData = pixi.MaskData;
var MaskSystem = pixi.MaskSystem;
var Matrix = pixi.Matrix;
var Mesh = pixi.Mesh;
var MeshBatchUvs = pixi.MeshBatchUvs;
var MeshGeometry = pixi.MeshGeometry;
var MeshMaterial = pixi.MeshMaterial;
var NineSlicePlane = pixi.NineSlicePlane;
var ObjectRenderer = pixi.ObjectRenderer;
var ObservablePoint = pixi.ObservablePoint;
var PI_2 = pixi.PI_2;
var PRECISION = pixi.PRECISION;
var ParticleContainer = pixi.ParticleContainer;
var ParticleRenderer = pixi.ParticleRenderer;
var PlaneGeometry = pixi.PlaneGeometry;
var Point = pixi.Point;
var Polygon = pixi.Polygon;
var Prepare = pixi.Prepare;
var Program = pixi.Program;
var ProjectionSystem = pixi.ProjectionSystem;
var Quad = pixi.Quad;
var QuadUv = pixi.QuadUv;
var RAD_TO_DEG = pixi.RAD_TO_DEG;
var RENDERER_TYPE = pixi.RENDERER_TYPE;
var Rectangle = pixi.Rectangle;
var RenderTexture = pixi.RenderTexture;
var RenderTexturePool = pixi.RenderTexturePool;
var RenderTextureSystem = pixi.RenderTextureSystem;
var Renderer = pixi.Renderer;
var Resource = pixi.Resource;
var RopeGeometry = pixi.RopeGeometry;
var RoundedRectangle = pixi.RoundedRectangle;
var Runner = pixi.Runner;
var SAMPLER_TYPES = pixi.SAMPLER_TYPES;
var SCALE_MODES = pixi.SCALE_MODES;
var SHAPES = pixi.SHAPES;
var SVGResource = pixi.SVGResource;
var ScissorSystem = pixi.ScissorSystem;
var Shader = pixi.Shader;
var ShaderSystem = pixi.ShaderSystem;
var SimpleMesh = pixi.SimpleMesh;
var SimplePlane = pixi.SimplePlane;
var SimpleRope = pixi.SimpleRope;
var Sprite = pixi.Sprite;
var SpriteMaskFilter = pixi.SpriteMaskFilter;
var Spritesheet = pixi.Spritesheet;
var SpritesheetLoader = pixi.SpritesheetLoader;
var State = pixi.State;
var StateSystem = pixi.StateSystem;
var StencilSystem = pixi.StencilSystem;
var System = pixi.System;
var TARGETS = pixi.TARGETS;
var TEXT_GRADIENT = pixi.TEXT_GRADIENT;
var TYPES = pixi.TYPES;
var TYPES_TO_BYTES_PER_COMPONENT = pixi.TYPES_TO_BYTES_PER_COMPONENT;
var TYPES_TO_BYTES_PER_PIXEL = pixi.TYPES_TO_BYTES_PER_PIXEL;
var TemporaryDisplayObject = pixi.TemporaryDisplayObject;
var Text = pixi.Text;
var TextMetrics = pixi.TextMetrics;
var TextStyle = pixi.TextStyle;
var Texture = pixi.Texture;
var TextureGCSystem = pixi.TextureGCSystem;
var TextureLoader = pixi.TextureLoader;
var TextureMatrix = pixi.TextureMatrix;
var TextureSystem = pixi.TextureSystem;
var TextureUvs = pixi.TextureUvs;
var Ticker = pixi.Ticker;
var TickerPlugin = pixi.TickerPlugin;
var TilingSprite = pixi.TilingSprite;
var TilingSpriteRenderer = pixi.TilingSpriteRenderer;
var TimeLimiter = pixi.TimeLimiter;
var Transform = pixi.Transform;
var UPDATE_PRIORITY = pixi.UPDATE_PRIORITY;
var UniformGroup = pixi.UniformGroup;
var VERSION = pixi.VERSION;
var VideoResource = pixi.VideoResource;
var ViewableBuffer = pixi.ViewableBuffer;
var WRAP_MODES = pixi.WRAP_MODES;
var accessibleTarget = pixi.accessibleTarget;
var autoDetectRenderer = pixi.autoDetectRenderer;
var autoDetectResource = pixi.autoDetectResource;
var checkMaxIfStatementsInShader = pixi.checkMaxIfStatementsInShader;
var createUBOElements = pixi.createUBOElements;
export default __pika_web_default_export_for_treeshaking__;
var defaultFilterVertex = pixi.defaultFilterVertex;
var defaultVertex = pixi.defaultVertex;
var filters = pixi.filters;
var generateProgram = pixi.generateProgram;
var generateUniformBufferSync = pixi.generateUniformBufferSync;
var getTestContext = pixi.getTestContext;
var getUBOData = pixi.getUBOData;
var graphicsUtils = pixi.graphicsUtils;
var groupD8 = pixi.groupD8;
var interactiveTarget = pixi.interactiveTarget;
var isMobile = pixi.isMobile;
var resources = pixi.resources;
var settings = pixi.settings;
var systems = pixi.systems;
var uniformParsers = pixi.uniformParsers;
var utils$1 = pixi.utils;
export { ALPHA_MODES, AbstractBatchRenderer, AbstractMultiResource, AbstractRenderer, AccessibilityManager, AnimatedSprite, AppLoaderPlugin, Application, ArrayResource, Attribute, BLEND_MODES, BUFFER_BITS, BUFFER_TYPE, BaseImageResource, BasePrepare, BaseRenderTexture, BaseTexture, BatchDrawCall, BatchGeometry, BatchPluginFactory, BatchRenderer, BatchShaderGenerator, BatchSystem, BatchTextureArray, BitmapFont, BitmapFontData, BitmapFontLoader, BitmapText, BlobResource, Bounds, Buffer, BufferResource, CLEAR_MODES, CanvasResource, Circle, CompressedTextureLoader, CompressedTextureResource, Container, ContextSystem, CountLimiter, CubeResource, DDSLoader, DEG_TO_RAD, DRAW_MODES, DisplayObject, ENV, Ellipse, Extract, FORMATS, FORMATS_TO_COMPONENTS, FillStyle, Filter, FilterState, FilterSystem, Framebuffer, FramebufferSystem, GC_MODES, GLFramebuffer, GLProgram, GLTexture, GRAPHICS_CURVES, Geometry, GeometrySystem, Graphics, GraphicsData, GraphicsGeometry, IGLUniformData, INSTALLED, INTERNAL_FORMATS, INTERNAL_FORMAT_TO_BYTES_PER_PIXEL, ImageBitmapResource, ImageResource, InteractionData, InteractionEvent, InteractionManager, InteractionTrackingData, KTXLoader, LINE_CAP, LINE_JOIN, LineStyle, Loader, LoaderResource, MASK_TYPES, MIPMAP_MODES, MSAA_QUALITY, MaskData, MaskSystem, Matrix, Mesh, MeshBatchUvs, MeshGeometry, MeshMaterial, NineSlicePlane, ObjectRenderer, ObservablePoint, PI_2, PRECISION, ParticleContainer, ParticleRenderer, PlaneGeometry, Point, Polygon, Prepare, Program, ProjectionSystem, Quad, QuadUv, RAD_TO_DEG, RENDERER_TYPE, Rectangle, RenderTexture, RenderTexturePool, RenderTextureSystem, Renderer, Resource, RopeGeometry, RoundedRectangle, Runner, SAMPLER_TYPES, SCALE_MODES, SHAPES, SVGResource, ScissorSystem, Shader, ShaderSystem, SimpleMesh, SimplePlane, SimpleRope, Sprite, SpriteMaskFilter, Spritesheet, SpritesheetLoader, State, StateSystem, StencilSystem, System, TARGETS, TEXT_GRADIENT, TYPES, TYPES_TO_BYTES_PER_COMPONENT, TYPES_TO_BYTES_PER_PIXEL, TemporaryDisplayObject, Text, TextMetrics, TextStyle, Texture, TextureGCSystem, TextureLoader, TextureMatrix, TextureSystem, TextureUvs, Ticker, TickerPlugin, TilingSprite, TilingSpriteRenderer, TimeLimiter, Transform, UPDATE_PRIORITY, UniformGroup, VERSION, VideoResource, ViewableBuffer, WRAP_MODES, pixi as __moduleExports, accessibleTarget, autoDetectRenderer, autoDetectResource, checkMaxIfStatementsInShader, createUBOElements, defaultFilterVertex, defaultVertex, filters, generateProgram, generateUniformBufferSync, getTestContext, getUBOData, graphicsUtils, groupD8, interactiveTarget, isMobile, resources, settings, systems, uniformParsers, utils$1 as utils };
